import { getAuth, updatePassword } from "firebase/auth";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";

const changePassword = async (data) => {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
        throw new Error("User not authenticated");
    }

    await updatePassword(user, data.password);
};

export const useChangePassword = (setReauthenticated) => {
    const navigate = useNavigate();

    return useMutation({
        mutationFn: changePassword,
        retry: false,
        onSuccess: () => {
            toast.success("Password successfully reset");
            navigate(-1);
        },
        onError: (err) => {
            if (err.code === "auth/requires-recent-login") {
                setReauthenticated(false);
            } else if (
                err.code === "auth/password-does-not-meet-requirements"
            ) {
                toast.error("Password does not meet policy requirements");
            } else {
                toast.error("Something went wrong");
            }
        },
    });
};
